(()=>{
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
function init(scope=document){
 scope.querySelectorAll('[data-dialog]').forEach(b=>{if(b.dataset.bound)return;b.dataset.bound='1';b.addEventListener('click',()=>{const d=document.getElementById(b.dataset.dialog);if(!d)return;d.showModal();document.body.style.overflow='';if(!reduced.matches)d.animate([{opacity:0,transform:'translateX(24px)'},{opacity:1,transform:'translateX(0)'}],{duration:240});});});
 scope.querySelectorAll('dialog').forEach(d=>{if(d.dataset.bound)return;d.dataset.bound='1';d.querySelectorAll('.close,.close-text,a').forEach(b=>b.addEventListener('click',()=>d.close()));d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()});});
 scope.querySelectorAll('.testimonials').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='1';const track=section.querySelector('.testimonial-track'),prev=section.querySelector('#review-prev'),next=section.querySelector('#review-next');if(!track||!prev||!next)return;function sync(){prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2}prev.onclick=()=>track.scrollBy({left:-track.clientWidth,behavior:reduced.matches?'instant':'smooth'});next.onclick=()=>track.scrollBy({left:track.clientWidth,behavior:reduced.matches?'instant':'smooth'});track.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(track);sync();});
 scope.querySelectorAll('.marquee-pause').forEach(b=>{if(b.dataset.bound)return;b.dataset.bound='1';b.onclick=()=>{const paused=b.closest('.media-marquee').classList.toggle('is-paused');b.setAttribute('aria-pressed',String(paused));b.setAttribute('aria-label',paused?'Reprendre le défilement':'Mettre le défilement en pause');b.firstElementChild.textContent=paused?'▶':'Ⅱ';};});
 scope.querySelectorAll('.product-gallery').forEach(gallery=>{
  if(gallery.dataset.galleryBound)return;
  gallery.dataset.galleryBound='1';
  const media=[...gallery.querySelectorAll('[data-media]')];
  const thumbs=[...gallery.querySelectorAll('[data-media-target]')];
  if(!media.length)return;
  let active=Math.max(0,media.findIndex(m=>!m.hidden));
  function show(index){
   active=(index+media.length)%media.length;
   media.forEach((m,i)=>{
    m.hidden=i!==active;
    if(m.hidden){
     m.querySelectorAll('video').forEach(v=>v.pause());
     m.querySelectorAll('iframe').forEach(f=>{const src=f.getAttribute('src');if(src)f.setAttribute('src',src);});
    }
   });
   thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.mediaTarget===media[active].dataset.media)));
   const activeThumb=thumbs.find(t=>t.dataset.mediaTarget===media[active].dataset.media);
   if(activeThumb){const strip=activeThumb.parentElement;if(strip)strip.scrollTo({left:activeThumb.offsetLeft-strip.clientWidth/2+activeThumb.offsetWidth/2,behavior:reduced.matches?'instant':'smooth'});}
  }
  thumbs.forEach(t=>t.addEventListener('click',()=>{const index=media.findIndex(m=>m.dataset.media===t.dataset.mediaTarget);if(index>=0)show(index);}));
  gallery.querySelectorAll('[data-gallery-step]').forEach(b=>b.addEventListener('click',()=>show(active+Number(b.dataset.galleryStep))));
  gallery.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key)||!e.target.closest('.gallery-arrow,.gallery-thumb'))return;e.preventDefault();show(active+(e.key==='ArrowRight'?1:-1));});
  show(active);
 });
 scope.querySelectorAll('[data-variant]').forEach(select=>{if(select.dataset.bound)return;select.dataset.bound='1';select.onchange=()=>{const o=select.selectedOptions[0],section=select.closest('.product-overview');section.querySelector('[data-price]').textContent=o.dataset.price;const compare=section.querySelector('[data-compare]'),saving=section.querySelector('[data-saving]');if(compare){compare.textContent=o.dataset.compare;compare.hidden=!o.dataset.compare}if(saving){saving.textContent='Économisez '+o.dataset.saving;saving.hidden=!o.dataset.saving}select.form.querySelector('[data-add]').disabled=o.dataset.available!=='true';const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);};});
 if(!reduced.matches&&'IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(!e.isIntersecting)return;observer.unobserve(e.target);if(e.boundingClientRect.top<80)return;e.target.animate([{opacity:.2,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:440,easing:'cubic-bezier(.2,.7,.2,1)'});});},{threshold:.08});scope.querySelectorAll('.benefit-card,.audience-grid article,.section-intro,.expert-inner').forEach(el=>{if(el.dataset.revealBound)return;el.dataset.revealBound='1';observer.observe(el);});}
}
init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
(()=>{
if(window.heativaDrawerInstalled)return;
window.heativaDrawerInstalled=true;

const root=window.Shopify?.routes?.root||'/';

const style=document.createElement('style');
style.textContent=`
#hv-cart{
  position:fixed;
  inset:0 0 0 auto;
  margin:0;
  width:min(460px,100%);
  height:100%;
  max-height:100%;
  max-width:100%;
  padding:0;
  border:0;
  background:#FFFCF5;
  color:#252525;
  font:16px/1.5 Inter,sans-serif;
  box-shadow:-12px 0 48px #25252526;
}
#hv-cart::backdrop{
  background:#25252570;
  backdrop-filter:blur(3px);
}
#hv-cart *{box-sizing:border-box}
#hv-cart button,#hv-cart a{font:inherit}
#hv-cart .hv-inner{
  display:flex;
  flex-direction:column;
  height:100%;
}
#hv-cart header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:16px 24px;
  border-bottom:1px solid #2525251a;
}
#hv-cart h2{
  font:700 26px Lora,serif;
  margin:0;
}
#hv-cart button{
  cursor:pointer;
  color:#252525;
}
#hv-cart .hv-close{
  border:0;
  background:none;
  width:48px;
  height:48px;
  font-size:30px;
}
#hv-cart .hv-shipping{
  text-align:center;
  padding:18px;
  font-weight:700;
}
#hv-cart .hv-scroll{
  flex:1;
  min-height:0;
  overflow:auto;
  padding:0 24px;
}
#hv-cart .hv-item{
  display:grid;
  grid-template-columns:80px 1fr;
  gap:16px;
  padding:22px 0;
  border-bottom:1px solid #2525251a;
}
#hv-cart .hv-item img{
  width:80px;
  height:80px;
  object-fit:contain;
  border-radius:6px;
  background:#F7F3E9;
}
#hv-cart .hv-name{
  font-weight:600;
  display:block;
  color:#252525;
  text-decoration:none;
}
#hv-cart .hv-controls{
  display:flex;
  align-items:center;
  gap:8px;
  margin:12px 0;
}
#hv-cart .hv-controls button{
  width:48px;
  height:48px;
  border:1px solid #25252526;
  border-radius:6px;
  background:none;
}
#hv-cart .hv-remove{
  border:0;
  background:none;
  text-decoration:underline;
  min-height:48px;
}
#hv-cart .hv-price{
  text-align:right;
  font-weight:700;
}
#hv-cart footer{
  padding:20px 24px;
  border-top:1px solid #2525251a;
  background:#F7F3E9;
}
#hv-cart .hv-total{
  display:flex;
  justify-content:space-between;
  gap:12px;
  margin-bottom:16px;
}
#hv-cart .hv-checkout{
  display:block;
  text-align:center;
  padding:15px;
  border-radius:8px;
  background:#B03730;
  color:#F7F3E9;
  text-decoration:none;
  font-weight:600;
}
#hv-cart .hv-error{
  color:#B03730;
  padding:0 24px;
  white-space:pre-line;
}
#hv-cart .hv-error:empty{display:none}
#hv-cart [hidden]{display:none!important}
#hv-cart button:disabled{
  opacity:.5;
  cursor:wait;
}
@media(max-width:749px){
  #hv-cart{
    inset:auto 0 0;
    width:100%;
    height:76vh;
    height:76dvh;
    border-radius:22px 22px 0 0;
    padding-bottom:env(safe-area-inset-bottom);
  }
}
`;
document.head.append(style);

const dialog=document.createElement('dialog');
dialog.id='hv-cart';
dialog.setAttribute('aria-labelledby','hv-cart-title');
dialog.innerHTML=`
<div class="hv-inner">
  <header>
    <h2 id="hv-cart-title">Votre panier</h2>
    <button type="button" class="hv-close" aria-label="Fermer">×</button>
  </header>
  <div class="hv-shipping">Livraison offerte 🎁</div>
  <p class="hv-error" role="alert"></p>
  <div class="hv-scroll"></div>
  <footer>
    <div class="hv-total">
      <span>Sous-total</span>
      <strong class="hv-sum"></strong>
    </div>
    <a class="hv-checkout">Passer au paiement</a>
  </footer>
</div>
`;
document.body.append(dialog);
dialog.querySelector('footer').hidden=true;
dialog.querySelector('.hv-checkout').href=root+'checkout';

const list=dialog.querySelector('.hv-scroll');
const error=dialog.querySelector('.hv-error');
let busy=false,oldOverflow='',opener;

const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({
  '&':'&amp;',
  '<':'&lt;',
  '>':'&gt;',
  '"':'&quot;',
  "'":'&#39;'
}[c]));

async function api(path,options){
  const response=await fetch(root+path,{
    credentials:'same-origin',
    ...options
  });
  const data=await response.json();
  if(!response.ok){
    throw new Error(
      data.description||
      data.message||
      'Impossible de mettre le panier à jour.'
    );
  }
  return data;
}

function render(cart){
  const money=n=>new Intl.NumberFormat('fr-CH',{
    style:'currency',
    currency:cart.currency
  }).format(n/100);

  list.innerHTML=cart.items.length
    ?cart.items.map(item=>`
      <article class="hv-item">
        ${item.image
          ?'<img src="'+esc(item.image)+'" alt="'+esc(item.product_title)+'">'
          :'<div></div>'}
        <div>
          <a class="hv-name" href="${esc(item.url)}">
            ${esc(item.product_title)}
          </a>
          <div class="hv-controls">
            <button type="button"
              data-key="${esc(item.key)}"
              data-quantity="${item.quantity-1}"
              aria-label="Diminuer la quantité">−</button>
            <span>${item.quantity}</span>
            <button type="button"
              data-key="${esc(item.key)}"
              data-quantity="${item.quantity+1}"
              aria-label="Augmenter la quantité">+</button>
          </div>
          <button type="button" class="hv-remove"
            data-key="${esc(item.key)}"
            data-quantity="0">Supprimer</button>
          <div class="hv-price">
            ${esc(money(item.final_line_price))}
          </div>
        </div>
      </article>
    `).join('')
    :'<p>Votre panier est vide.</p>';

  dialog.querySelector('.hv-sum').textContent=money(cart.total_price);
  dialog.querySelector('.hv-checkout').hidden=!cart.item_count;
  dialog.querySelector('footer').hidden=!cart.item_count;

  document.querySelectorAll(
    '.cart-count,.cart-count-bubble span[aria-hidden="true"]'
  ).forEach(el=>el.textContent=cart.item_count);
}

function open(){
  if(dialog.open)return;
  opener=document.activeElement;
  oldOverflow=document.body.style.overflow;
  dialog.showModal();
  document.body.style.overflow='hidden';

  if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
    dialog.animate([
      {transform:innerWidth<750?'translateY(100%)':'translateX(100%)'},
      {transform:'translate(0)'}
    ],{
      duration:300,
      easing:'cubic-bezier(.2,.7,.2,1)'
    });
  }
}

dialog.querySelector('.hv-close').onclick=()=>dialog.close();

dialog.addEventListener('close',()=>{
  document.body.style.overflow=oldOverflow;
  opener?.focus();
});

dialog.addEventListener('click',e=>{
  if(e.target!==dialog)return;
  const r=dialog.getBoundingClientRect();
  if(
    e.clientX<r.left||e.clientX>r.right||
    e.clientY<r.top||e.clientY>r.bottom
  )dialog.close();
});

document.addEventListener('submit',async e=>{
  const form=e.target;
  if(
    !(form instanceof HTMLFormElement)||
    !new URL(form.action,location.href).pathname.match(
      /\/cart\/add(?:\.js)?\/?$/
    )
  )return;

  e.preventDefault();
  e.stopImmediatePropagation();
  if(busy)return;

  const data=new FormData(form);
  const button=form.querySelector(
    '[data-add],button[name="add"],button[type="submit"]'
  );

  busy=true;
  if(button)button.disabled=true;
  error.textContent='';

  try{
    await api('cart/add.js',{method:'POST',body:data});
    open();

    try{
      render(await api('cart.js'));
    }catch{
      error.textContent=
        'Article ajouté. Fermez puis rouvrez le panier pour actualiser son contenu.';
    }
  }catch(err){
    open();
    error.textContent=err.message;
  }finally{
    busy=false;
    if(button)button.disabled=false;
  }
},true);

document.addEventListener('click',async e=>{
  const link=e.target.closest('a[href]');
  if(
    !link||e.ctrlKey||e.metaKey||e.shiftKey||
    e.altKey||e.button!==0
  )return;

  const url=new URL(link.href,location.href);
  if(
    url.origin!==location.origin||
    !url.pathname.match(/\/cart\/?$/)
  )return;

  e.preventDefault();
  e.stopImmediatePropagation();
  if(busy)return;

  busy=true;
  error.textContent='';
  open();

  try{
    render(await api('cart.js'));
  }catch(err){
    error.textContent=err.message;
  }finally{
    busy=false;
  }
},true);

list.addEventListener('click',async e=>{
  const button=e.target.closest('button[data-key]');
  if(!button||busy)return;

  const quantity=Number(button.dataset.quantity);
  busy=true;
  error.textContent='';
  list.querySelectorAll('button').forEach(b=>b.disabled=true);

  try{
    render(await api('cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({
        id:button.dataset.key,
        quantity
      })
    }));
  }catch(err){
    error.textContent=err.message;
  }finally{
    busy=false;
    list.querySelectorAll('button').forEach(b=>b.disabled=false);
  }
});
})();